import { BarrioModel } from './barrio.model';

export class SubBarrioModel {

  id: number;
  nombre: string;
  barrio: BarrioModel;
  idSubBarrioEsri: number;

  constructor() {
    this.nombre = '';
    this.barrio = new BarrioModel();
    this.idSubBarrioEsri = null;
  }
}
